import {
  GET_INTEGRATION_SUCCESS,
  DELETE_INTEGRATION_REQUEST,
  DELETE_INTEGRATION_FAILURE
} from '../../../actions/api/integration';
import { SINGINT_INITIALIZE } from '../../../actions/page/admin/SingleIntegration';

export default function SingleIntegration(state = {}, action) {
  switch (action.type) {
    case SINGINT_INITIALIZE:
      const defaults = {
        deleting: false,
        loadingInt: true,
        integrationID: null
      };
      return {
        ...state,
        ...defaults
      };
    case GET_INTEGRATION_SUCCESS:
      return {
        ...state,
        integrationID: action.response.result,
        loadingInt: false
      };
    case DELETE_INTEGRATION_REQUEST:
      return {
        ...state,
        deleting: true
      };
    case DELETE_INTEGRATION_FAILURE:
      return {
        ...state,
        deleting: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/admin/SingleIntegration.js